module.exports = __webpack_public_path__ + "img/guandai_xc8.24044318.jpg";